<template>
  <div
    class="season-container"
    :style="`height: ${size}; width: ${size};`"
    :title="title"
  >
    <div class="svg-season-container">
      <svg
        viewBox="0 0 11.812431 11.722035"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(-41.175977,-37.359951)">
          <path
            :class="seasons.includes('winter') ? 'active-winter' : 'inactive-season'"
            d="m 46.410759,46.95209 -0.61648,0.164041 -0.529166,-0.29898 v -0.762 l 0.529166,-0.298979 0.61648,0.164042 0.137583,-0.510646 -0.468313,-0.124353 0.121709,-0.468314 -0.510646,-0.137583 -0.164042,0.616479 -0.529166,0.29898 -0.64823,-0.381 v -0.597958 l 0.452438,-0.452438 -0.375708,-0.373062 -0.341313,0.341312 -0.341312,-0.341312 -0.375709,0.373062 0.452438,0.452438 v 0.597958 l -0.661459,0.381 -0.529166,-0.29898 -0.153459,-0.616479 -0.508,0.137583 0.124355,0.468314 -0.468313,0.124353 0.137583,0.510646 0.61648,-0.164042 0.529166,0.298979 v 0.764646 l -0.529166,0.29898 -0.61648,-0.164041 -0.137583,0.510645 0.468313,0.124355 -0.124355,0.465666 0.510646,0.137583 0.164042,-0.61648 0.529167,-0.298979 0.648229,0.381 v 0.597959 l -0.452438,0.452437 0.375709,0.373064 0.341312,-0.341313 0.341313,0.341313 0.373062,-0.373064 -0.449792,-0.452437 v -0.597959 l 0.661459,-0.383646 0.529166,0.29898 0.164042,0.616479 0.497417,-0.134938 -0.124354,-0.468312 0.468312,-0.124354 -0.134937,-0.510646 m -2.987146,-0.896938 0.661458,-0.383645 0.661458,0.383645 v 0.762 l -0.661458,0.383646 -0.661458,-0.383646 z"
            style="stroke-width:0.264583"
          />
          <path
            :class="seasons.includes('summer') ? 'active-summer' : 'inactive-season'"
            d="m 41.850665,42.146262 0.373063,0.373063 0.47625,-0.473604 -0.375708,-0.375709 m 1.762124,-2.987145 c -0.875771,0 -1.587499,0.711729 -1.587499,1.5875 0,0.875771 0.711728,1.5875 1.587499,1.5875 0.875771,0 1.5875,-0.71173 1.5875,-1.5875 0,-0.878417 -0.71173,-1.5875 -1.5875,-1.5875 m 2.116667,1.852083 h 0.79375 v -0.529167 h -0.79375 m -0.73025,2.039938 0.47625,0.473604 0.373063,-0.373063 -0.473604,-0.47625 m 0.473604,-3.251729 -0.373063,-0.370415 -0.47625,0.473604 0.375709,0.375708 m -1.497542,-1.537229 h -0.529167 v 0.79375 h 0.529167 m -1.651001,0.367771 -0.47625,-0.473604 -0.373063,0.370415 0.473605,0.478896 0.375708,-0.375708 m -1.524,2.013479 h 0.793751 v -0.529167 h -0.793751 m 3.175,2.38125 H 43.82181 v 0.79375 h 0.529167"
            style="stroke-width:0.264583"
          />
          <path
            :class="seasons.includes('autumn') ? 'active-autumn' : 'inactive-season'"
            d="m 52.829658,40.402655 -1.531938,0.79375 0.264584,0.529167 -1.058334,-0.198438 v 0.992188 h -0.529166 v -0.992188 l -1.058334,0.198438 0.264584,-0.529167 -1.531938,-0.79375 0.264584,-0.457729 -0.423334,-0.865187 0.9525,-0.06085 0.264584,-0.468312 0.904875,1.031875 -0.431271,-1.296458 h 0.529166 l 0.529167,-0.79375 0.529167,0.79375 h 0.529166 l -0.43127,1.296458 0.904875,-1.031875 0.264583,0.457729 0.9525,0.06085 -0.423333,0.854604 z"
            style="stroke-width:0.264583"
          />
          <path
            :class="seasons.includes('spring') ? 'active-spring' : 'inactive-season'"
            d="m 47.858137,46.568443 a 2.38125,2.38125 0 0 0 2.38125,2.38125 c 0,-1.322916 -1.066271,-2.38125 -2.38125,-2.38125 m 2.38125,-1.984375 a 0.66145833,0.66145833 0 0 1 0.661458,0.661459 0.66145833,0.66145833 0 0 1 -0.661458,0.661458 0.66145833,0.66145833 0 0 1 -0.661458,-0.661458 0.66145833,0.66145833 0 0 1 0.661458,-0.661459 m -1.693333,1.256771 a 0.66145833,0.66145833 0 0 0 0.661458,0.661459 c 0.140229,0 0.269875,-0.04498 0.370417,-0.116417 0,0.01587 0,0.03175 0,0.05027 a 0.66145833,0.66145833 0 0 0 0.661458,0.661458 0.66145833,0.66145833 0 0 0 0.661458,-0.661458 c 0,-0.01852 0,-0.0344 0,-0.05027 0.100542,0.07144 0.230188,0.116416 0.370417,0.116416 0.365125,0 0.661458,-0.296333 0.661458,-0.661458 0,-0.264583 -0.156104,-0.489479 -0.378354,-0.595312 0.22225,-0.105834 0.378354,-0.333375 0.378354,-0.595313 0,-0.365125 -0.296333,-0.661458 -0.661458,-0.661458 -0.140229,0 -0.269875,0.04233 -0.370417,0.116416 0,-0.01588 0,-0.0344 0,-0.05027 a 0.66145833,0.66145833 0 0 0 -0.661458,-0.661459 0.66145833,0.66145833 0 0 0 -0.661458,0.661459 c 0,0.01587 0,0.0344 0,0.05027 -0.100542,-0.07408 -0.230188,-0.116417 -0.370417,-0.116417 a 0.66145833,0.66145833 0 0 0 -0.661458,0.661458 c 0,0.261938 0.156104,0.489479 0.378354,0.595313 -0.22225,0.105833 -0.378354,0.330729 -0.378354,0.595312 m 1.693333,3.108854 a 2.38125,2.38125 0 0 0 2.38125,-2.38125 c -1.322917,0 -2.38125,1.058334 -2.38125,2.38125 z"
            style="stroke-width:0.264583"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Season',

  props: {
    size: {
      type: String,
      default: '1.8em'
    },
    seasons: {
      type: Array,
      required: true
    }
  },

  computed: {
    title () {
      const titles = []
      for (const season of this.seasons) {
        titles.push(this.$t(`models.seasons.${season}`))
      }
      return titles.join(', ')
    }
  }
}
</script>

<style lang="scss">
.season-container {
  vertical-align: middle;
  display: inline-block;
  .svg-season-container {
    vertical-align: baseline;
    display: inline-block;
    position: relative;
    width: 100%;
    padding-bottom: 100%;
    overflow: hidden;
    transition: transform 0.2s;
    svg {
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      .active-summer {
        fill: #fdd835
      }
      .active-spring {
        fill: #8bc34a
      }
      .active-autumn {
        fill: #b71c1c
      }
      .active-winter {
        fill: #90caf9
      }
    }
    &:hover {
      transform: scale(175%);
    }
  }
}
.theme--light {
  .season-container .svg-season-container svg {
    .inactive-season {
      fill: rgba(0, 0, 0, 0)
    }
  }
}
.theme--dark {
  .season-container .svg-season-container svg {
    .inactive-season {
      fill: rgba(255, 255, 255, 0)
    }
  }
}
</style>
